import html2canvas from "html2canvas";
import { emitIntent } from "./emitIntent";

export const generateImage = (divRef, toggleErrorModal, ticketNumber) => {
    const title = ticketNumber != null ? `ticket_image_${ticketNumber}.png` : 'ticket_image.png';
    
    if (divRef && divRef.current) {
      html2canvas(divRef.current)
        .then(canvas => {
          const imgData = canvas.toDataURL('image/png');

          try {
            const link = document.createElement('a');
            link.href = imgData;
            link.download = title;
            link.click();
          } catch (err) {
            emitIntent("download_file", { title, content: imgData });
          }
        })
        .catch(error => {
          console.error('Erro ao gerar imagem:', error);
          if (toggleErrorModal) toggleErrorModal('Erro ao gerar imagem', 'Não foi possível gerar sua imagem.');
        });
    }
  };

  export const shareImage = (divRef, toggleErrorModal, ticketNumber) => {
    const title = ticketNumber != null ? `ticket_image_${ticketNumber}.png` : 'ticket_image.png';

    if (divRef && divRef.current) {
      html2canvas(divRef.current)
        .then(canvas => {
          const imgData = new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
          const files = [new File([imgData], title, { type: 'image/png' })];

          if (window.parent) {
            emitIntent("share_files", { files })
          } else {
            if (toggleErrorModal) toggleErrorModal('Navegador incompatível', 'O método de compartilhamento de imagem não está disponível em seu navegador.');
          }

        })
        .catch(error => {
          console.error('Erro ao gerar imagem:', error);
          if (toggleErrorModal) toggleErrorModal('Erro ao gerar imagem', 'Não foi possível gerar sua imagem.');
        });
    }
  };


// WEBPACK FOOTER //
// ./src/newDesign/utils/generateImage.js